// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timepicker-container {
    position: relative;
    width: 100%;
}

.timepicker-container .input-group {
    flex-wrap: nowrap;
}

.timepicker-container .input-group .form-control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.timepicker-container .input-group .btn-calendar {
    background-color: #172228;
    border-color: #172228;
    color: #ffffff;
    padding: 0.375rem 0.75rem;
}

.timepicker-container .input-group .btn-calendar:hover,
.timepicker-container .input-group .btn-calendar:focus,
.timepicker-container .input-group .btn-calendar:active {
    background-color: #31414b;
    border-color: #31414b;
    color: #ffffff;
}

.timepicker-container .input-group .btn-clear {
    background-color: #dc3545;
    border-color: #dc3545;
    color: #ffffff;
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
}

.timepicker-container .input-group .btn-clear:hover {
    background-color: #bb2d3b;
    border-color: #bb2d3b;
    color: #ffffff;
}

.timepicker-container .input-group .btn:focus {
    box-shadow: none;
}

.timepicker-clear-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: #172228;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.timepicker-clear-icon:hover {
    background: #dc3545;
    opacity: 1;
    transform: translateY(-50%);
}

.timepicker-clear-icon::after {
    content: "×";
    background: transparent;
    color: #ffffff;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.timepicker-dropdown {
    position: fixed;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    max-height: 300px;
    overflow: hidden;
    margin-top: 2px;
    min-width: 150px;
}

.timepicker-header {
    background: #172228;
    color: white;
    padding: 12px 16px;
    font-weight: 600;
    font-size: 14px;
    text-align: center;
    border-radius: 8px 8px 0 0;
}

.timepicker-list {
    max-height: 250px;
    overflow-y: auto;
    padding: 4px 0;
}

.timepicker-item {
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;
    color: #000;
    transition: all 0.2s ease;
    text-align: center;
    border-bottom: 1px solid #f8f9fa;
}

.timepicker-item:hover {
    background-color: #f8f9fa;
    color: #172228;
}

.timepicker-item.selected {
    background-color: #172228;
    color: white;
    font-weight: 600;
}

.timepicker-item:last-child {
    border-bottom: none;
}

/* Scrollbar customizado */
.timepicker-list::-webkit-scrollbar {
    width: 6px;
}

.timepicker-list::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.timepicker-list::-webkit-scrollbar-thumb {
    background: #172228;
    border-radius: 3px;
}

.timepicker-list::-webkit-scrollbar-thumb:hover {
    background: #0d1419;
}

/* Modal específico - z-index maior */
.modal .timepicker-dropdown {
    z-index: 1080;
}

/* Responsivo */
@media (max-width: 768px) {
    .timepicker-dropdown {
        max-height: 280px;
        min-width: 200px;
        left: 50% !important;
        transform: translateX(-50%);
        max-width: calc(100vw - 20px);
    }

    .timepicker-list {
        max-height: 230px;
    }

    .timepicker-item {
        padding: 12px 16px;
        font-size: 16px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timepicker-header {
        padding: 14px 16px;
        font-size: 16px;
    }

    /* Ajustar posição para não sair da tela */
    .modal .timepicker-dropdown {
        position: fixed;
        z-index: 1080;
    }

    /* Melhorar área de toque */
    .timepicker-clear-icon {
        width: 24px;
        height: 24px;
        right: 8px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/timepicker-custom.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,aAAa;AACjB;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;QACpB,2BAA2B;QAC3B,6BAA6B;IACjC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA,0CAA0C;IAC1C;QACI,eAAe;QACf,aAAa;IACjB;;IAEA,2BAA2B;IAC3B;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;AACJ","sourcesContent":[".timepicker-container {\n    position: relative;\n    width: 100%;\n}\n\n.timepicker-container .input-group {\n    flex-wrap: nowrap;\n}\n\n.timepicker-container .input-group .form-control {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.timepicker-container .input-group .btn-calendar {\n    background-color: #172228;\n    border-color: #172228;\n    color: #ffffff;\n    padding: 0.375rem 0.75rem;\n}\n\n.timepicker-container .input-group .btn-calendar:hover,\n.timepicker-container .input-group .btn-calendar:focus,\n.timepicker-container .input-group .btn-calendar:active {\n    background-color: #31414b;\n    border-color: #31414b;\n    color: #ffffff;\n}\n\n.timepicker-container .input-group .btn-clear {\n    background-color: #dc3545;\n    border-color: #dc3545;\n    color: #ffffff;\n    padding: 0.375rem 0.75rem;\n    font-size: 0.8rem;\n}\n\n.timepicker-container .input-group .btn-clear:hover {\n    background-color: #bb2d3b;\n    border-color: #bb2d3b;\n    color: #ffffff;\n}\n\n.timepicker-container .input-group .btn:focus {\n    box-shadow: none;\n}\n\n.timepicker-clear-icon {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #172228;\n    border-radius: 4px;\n    width: 20px;\n    height: 20px;\n    opacity: 0.8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.timepicker-clear-icon:hover {\n    background: #dc3545;\n    opacity: 1;\n    transform: translateY(-50%);\n}\n\n.timepicker-clear-icon::after {\n    content: \"×\";\n    background: transparent;\n    color: #ffffff;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 1;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.timepicker-dropdown {\n    position: fixed;\n    background: white;\n    border: 1px solid #dee2e6;\n    border-radius: 8px;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);\n    z-index: 9999;\n    max-height: 300px;\n    overflow: hidden;\n    margin-top: 2px;\n    min-width: 150px;\n}\n\n.timepicker-header {\n    background: #172228;\n    color: white;\n    padding: 12px 16px;\n    font-weight: 600;\n    font-size: 14px;\n    text-align: center;\n    border-radius: 8px 8px 0 0;\n}\n\n.timepicker-list {\n    max-height: 250px;\n    overflow-y: auto;\n    padding: 4px 0;\n}\n\n.timepicker-item {\n    padding: 8px 16px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #000;\n    transition: all 0.2s ease;\n    text-align: center;\n    border-bottom: 1px solid #f8f9fa;\n}\n\n.timepicker-item:hover {\n    background-color: #f8f9fa;\n    color: #172228;\n}\n\n.timepicker-item.selected {\n    background-color: #172228;\n    color: white;\n    font-weight: 600;\n}\n\n.timepicker-item:last-child {\n    border-bottom: none;\n}\n\n/* Scrollbar customizado */\n.timepicker-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.timepicker-list::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n}\n\n.timepicker-list::-webkit-scrollbar-thumb {\n    background: #172228;\n    border-radius: 3px;\n}\n\n.timepicker-list::-webkit-scrollbar-thumb:hover {\n    background: #0d1419;\n}\n\n/* Modal específico - z-index maior */\n.modal .timepicker-dropdown {\n    z-index: 1080;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n    .timepicker-dropdown {\n        max-height: 280px;\n        min-width: 200px;\n        left: 50% !important;\n        transform: translateX(-50%);\n        max-width: calc(100vw - 20px);\n    }\n\n    .timepicker-list {\n        max-height: 230px;\n    }\n\n    .timepicker-item {\n        padding: 12px 16px;\n        font-size: 16px;\n        min-height: 44px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .timepicker-header {\n        padding: 14px 16px;\n        font-size: 16px;\n    }\n\n    /* Ajustar posição para não sair da tela */\n    .modal .timepicker-dropdown {\n        position: fixed;\n        z-index: 1080;\n    }\n\n    /* Melhorar área de toque */\n    .timepicker-clear-icon {\n        width: 24px;\n        height: 24px;\n        right: 8px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
